import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import './ARConfigStyle.scss';
import ARService from './ARService';
import UseAutoCompleteSearch from '../../../Common/AutoComplete';
import { styled } from '@mui/material/styles';

const Label = styled('label')`
    display: block;
    font-weight: 700;
    color: #166c9d;
    margin-bottom: 4px;
    padding-right: 5px;
`;

class ARModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show,
            header: this.props.header,
            setSelectedDepartment: null,
            setSelectedClass: this.props.classSelected,
            setSelectedSpecialtyType: this.props.specialtySelected,
        };

        this.arService = new ARService();
    }

    /**
     * Handle on close
     */
    handleClose = () => {
        const { closeModal } = this.props;
        this.setState({
            show: false,
        });
        closeModal();
    };

    /**
     * Handle on close
     */
    saveArService = () => {
        const { customerId, userFullname, action, depSelected, refresh } = this.props;
        const { setSelectedDepartment, setSelectedClass, setSelectedSpecialtyType } = this.state;
        refresh(
            setSelectedDepartment,
            setSelectedClass,
            setSelectedSpecialtyType,
            customerId,
            userFullname,
            action,
            depSelected,
        );
        this.setState({
            show: false,
        });
    };
    searchLocation = (search) => {
        const { searchLocation } = this.props;
        searchLocation(search);
    };

    setSelectedDepartment = (value) => {
        this.setState({
            setSelectedDepartment: value,
        });
    };

    setSelectedSpecialtyType = (value) => {
        this.setState({
            setSelectedSpecialtyType: value,
        });
    };

    setSelectedClass = (value) => {
        this.setState({
            setSelectedClass: value,
        });
    };

    render() {
        const { show, header, setSelectedDepartment, setSelectedClass, setSelectedSpecialtyType } = this.state;
        const {
            departmentFilter,
            specialtyTypeFilter,
            thereapeuticClassFilter,
            action,
            location,
            depSelected = [],
            classSelected = [],
            specialtySelected = [],
        } = this.props;

        let isArrayEmpty = false;

        if (action == 'Save') {
            isArrayEmpty =
                setSelectedDepartment &&
                setSelectedDepartment.length > 0 &&
                setSelectedClass &&
                setSelectedClass.length > 0 &&
                setSelectedSpecialtyType &&
                setSelectedSpecialtyType.length > 0
                    ? false
                    : true;
        } else if (action == 'Update') {
            let objectsEqual = (first_array_of_objects, second_array_of_objects) => {
                return (
                    first_array_of_objects.length === second_array_of_objects.length &&
                    first_array_of_objects.every((element_1) =>
                        second_array_of_objects.some((element_2) =>
                            Object.keys(element_1).every((key) => element_1[key] === element_2[key]),
                        ),
                    )
                );
            };

            isArrayEmpty =
                (!objectsEqual(specialtySelected, setSelectedSpecialtyType) ||
                    !objectsEqual(classSelected, setSelectedClass)) &&
                setSelectedClass.length > 0 &&
                setSelectedSpecialtyType.length > 0
                    ? false
                    : true;
        }
        return (
            <>
                <Modal
                    className="modal-help use-auto-search-modal"
                    size="lg"
                    show={show}
                    onHide={this.handleClose}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{header}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {action == 'Save' ? (
                            <>
                                <Label>Search By : </Label>
                                <div className="body-content use-auto-search">
                                    <UseAutoCompleteSearch
                                        data={departmentFilter}
                                        label="Location"
                                        onSelectChange={this.setSelectedDepartment}
                                        selected={depSelected}
                                        noOptionsText="No Locations Available"
                                        search={this.searchLocation}
                                    />
                                    <UseAutoCompleteSearch
                                        data={specialtyTypeFilter}
                                        label="Specialty Type"
                                        onSelectChange={this.setSelectedSpecialtyType}
                                        selected={specialtySelected}
                                        noOptionsText="No Specialty Type Available"
                                    />
                                    <UseAutoCompleteSearch
                                        data={thereapeuticClassFilter}
                                        label="Therapeutic Class"
                                        onSelectChange={this.setSelectedClass}
                                        selected={classSelected}
                                        noOptionsText="No Therapeutic Class Available"
                                    />
                                </div>
                            </>
                        ) : null}
                        {action == 'Update' ? (
                            <div className="body-content">
                                <div className="update-div">
                                    {' '}
                                    <Label>Department/Location : </Label> <span>{location}</span>{' '}
                                </div>
                                <Label>Search By : </Label>
                                <div className="use-auto-search">
                                    <UseAutoCompleteSearch
                                        data={specialtyTypeFilter}
                                        label="Specialty Type"
                                        onSelectChange={this.setSelectedSpecialtyType}
                                        selected={specialtySelected}
                                        noOptionsText="No Specialty Type Available"
                                    />
                                    <UseAutoCompleteSearch
                                        data={thereapeuticClassFilter}
                                        label="Therapeutic Class"
                                        onSelectChange={this.setSelectedClass}
                                        selected={classSelected}
                                        noOptionsText="No Therapeutic Class Available"
                                    />
                                </div>
                            </div>
                        ) : null}
                        {action == 'Disable' ? (
                            <div>Are you sure you want to remove TherigyVista generated referrals for {location} ?</div>
                        ) : null}
                        <div className="body-footer text-right">
                            <Button
                                type="button"
                                className="submit-btn"
                                size="sm"
                                disabled={isArrayEmpty}
                                onClick={this.saveArService}
                            >
                                {action == 'Disable' ? 'Remove' : action}
                            </Button>
                            <Button type="button" className="submit-btn" size="sm" onClick={this.handleClose}>
                                Cancel
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

ARModal.propTypes = {
    show: PropTypes.bool.isRequired,
    header: PropTypes.object.isRequired,
    specialtySelected: PropTypes.object.isRequired,
    setShowARModal: PropTypes.object.isRequired,
    customerId: PropTypes.object.isRequired,
    userFullname: PropTypes.object.isRequired,
    depSelected: PropTypes.object.isRequired,
    classSelected: PropTypes.object.isRequired,
    departmentFilter: PropTypes.object.isRequired,
    specialtyTypeFilter: PropTypes.object.isRequired,
    thereapeuticClassFilter: PropTypes.object.isRequired,
    action: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    refresh: PropTypes.object.isRequired,
    closeModal: PropTypes.object.isRequired,
    searchLocation: PropTypes.object.isRequired,
};

export default ARModal;
